import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=70b26e6f&scoped=true&"
import script from "./LayoutBase.vue?vue&type=script&lang=js&"
export * from "./LayoutBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b26e6f",
  null
  
)

export default component.exports